import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "../components/SnackBar";
import { setLayersLoading } from "../redux/action/LayersLoading-action";
import { addWidgets, initializeMap } from "../utils/API";
import { ConfigContext } from "../utils/ConfigContext";
import { getDisclaimerText } from "../utils/helper";
import useCustomSnackbar from "./useCustomSnackbar";

const useEsriMap = ({
  elementRef,
  activeModule,
  activeLanguage,
  setActiveLanguage,
  setFeatureTableActive,
}) => {
  const [isLoading, setLoading] = useState(true);
  const [errors, setError] = useState([]);
  const { t, i18n } = useTranslation("common");
  const { config, setConfig } = useContext(ConfigContext);
  const mapReloadCount = useSelector(
    (store) => store.mapViewReducer.mapReloadCount
  );
  const [openSnackbar] = useSnackbar();
  const [openTopSnackbar] = useCustomSnackbar();
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
  }, [mapReloadCount]);

  useEffect(() => {
    if (!isLoading) return;
    dispatch(setLayersLoading(true));

    initializeMap({
      container: elementRef.current,
      config,
      setLoading,
      setError,
      activeModule,
      setActiveLanguage,
      t,
      i18n,
      openSnackbar,
      setConfig,
      openTopSnackbar,
    }).then(() => {});
    setLoading(false);
  }, [
    activeModule,
    isLoading,
    t,
    setActiveLanguage,
    i18n,
    setFeatureTableActive,
  ]);

  useEffect(() => {
    if (isLoading) return;

    addWidgets(config, activeModule, setActiveLanguage, i18n, t, openSnackbar);
  }, [activeLanguage]);

  useEffect(() => {
    const disclaimerNode = document.getElementById("disclaimerText");
    if (disclaimerNode)
      disclaimerNode.innerHTML = getDisclaimerText(config, activeModule, t);
  }, [config, activeModule]);

  return { isLoading, errors, setError };
};

export default useEsriMap;
